import http from "@/libs/http";
const common = {
  /**图形验证码 */
  verifyImage: () => {
    return http.formatUrl("common/verify/image");
  }
};
export default common;
